import { Label } from "@/components/ui/label";
import { PermissionCheckbox } from "@/components/ui/permission-checkbox";
import {
  isUiPermissionChecked,
  PERMISSION_UI_DEFS,
  toggleUiPermissionInTabs,
  type PermissionUiId,
} from "@/lib/userPermissions";

type UserPermissionsFieldProps = {
  value: string[];
  onChange: (tabs: string[]) => void;
  showHint?: boolean;
};

export function UserPermissionsField({ value, onChange, showHint = false }: UserPermissionsFieldProps) {
  const toggle = (uiId: PermissionUiId) => {
    onChange(toggleUiPermissionInTabs(value, uiId));
  };

  return (
    <div className="space-y-3 rounded-lg border border-gray-200 bg-muted/20 p-4">
      <Label className={showHint ? "text-base" : undefined}>Permissões por aba *</Label>
      {showHint ? (
        <p className="text-xs text-muted-foreground">Marque apenas as telas que este usuário pode acessar.</p>
      ) : null}
      <div className="grid grid-cols-1 gap-2 pt-1 sm:grid-cols-2">
        {PERMISSION_UI_DEFS.map((def) => (
          <PermissionCheckbox
            key={def.id}
            checked={isUiPermissionChecked(value, def.id)}
            label={def.label}
            onChange={() => toggle(def.id)}
          />
        ))}
      </div>
    </div>
  );
}
